export default __webpack_public_path__ + "static/footer-f491514cc656df16c9a34a495e4ddd11.png";